interface SkeletonProps {
  className?: string
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div 
      className={`animate-pulse bg-white/10 rounded ${className}`}
    />
  )
}

export function GameCardSkeleton() {
  return (
    <div className="bg-bg-primary/15 border border-secondary/30 px-4 py-3">
      <div className="flex items-center justify-between mb-2">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-14" />
      </div>
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-3 w-10" />
      </div>
      <div className="h-px bg-white/10 my-2" />
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-3 w-10" />
      </div>
      <Skeleton className="h-3 w-16 mt-2" />
    </div>
  )
}

export function ResultCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-48 bg-bg-primary/15 border border-secondary/30 px-3 py-3">
      <div className="flex items-center justify-between mb-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-5 w-8" />
      </div>
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-5 w-8" />
      </div>
    </div>
  )
}

export function StandingsRowSkeleton() {
  return (
    <div className="flex items-center justify-between px-3 py-2 border-b border-secondary/20">
      <div className="flex items-center gap-2">
        <Skeleton className="w-5 h-5" />
        <Skeleton className="h-4 w-20" />
      </div>
      <Skeleton className="h-4 w-10" />
    </div>
  )
}

export function StandingsSkeleton() {
  return (
    <div className="bg-bg-primary/12 border border-secondary/30">
      <div className="flex items-center justify-between px-3 py-2 border-b border-secondary/20">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-8" />
      </div>
      {[...Array(5)].map((_, i) => (
        <StandingsRowSkeleton key={i} />
      ))}
    </div>
  )
}

export function TeamCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-56 sm:w-64 text-center">
      <Skeleton className="w-40 h-40 sm:w-44 sm:h-44 mx-auto mb-6 rounded-full" />
      <Skeleton className="h-6 w-24 mx-auto" />
    </div>
  )
}

